import { type RouteRecordRaw } from 'vue-router';
import { advertRoutes } from 'src/router/info/advertRoutes';
import { affiliateRoutes } from 'src/router/info/affiliateRoutes';
import { infoProductRoutes } from 'src/router/info/productRoutes';
import { infoProductCategoryRoutes } from 'src/router/info/productCategoryRoutes';
import { infoFeatureCategoryRoutes } from 'src/router/info/featureCategoryRoutes';
import { infoFeatureRoutes } from 'src/router/info/featureRoutes';
import { infoFeatureItemRoutes } from 'src/router/info/featureItemRoutes';
import { infoSurveyRoutes } from 'src/router/info/infoSurveyRoutes';
import { newsRoutes } from 'src/router/info/newsRoutes';
// import { solutionRoutes } from 'src/router/info/solutionRoutes';
import { geneRoutes } from 'src/router/info/geneRoutes';
import { forexRoutes } from 'src/router/info/forexRoutes';
import { infoSupportRoutes } from 'src/router/info/infoSupportRoutes';

export const infoRoutes: Array<RouteRecordRaw> = [
  ...infoProductRoutes,
  ...infoProductCategoryRoutes,
  ...infoFeatureCategoryRoutes,
  ...infoFeatureRoutes,
  ...infoFeatureItemRoutes,
  ...infoSurveyRoutes,
  ...infoSupportRoutes,
  ...newsRoutes,
  // ...solutionRoutes,
  ...geneRoutes,
  ...forexRoutes,
  ...advertRoutes,
  ...affiliateRoutes,
];
